export default "__VITE_ASSET__C279VNd0__"